'use client';

import classNames from 'classnames';
import { memo, useEffect, useState } from 'react';

import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import useSubscription from '@/hooks/useSubscription';

import Pricing from './components/Pricing';
import RemainCredits from './components/RemainCredits';
import { StripeBillingEntry } from './components/StripeBillingEntry';
import UsageCurrentKey from './components/UsageCurrentKey';

function Subscription(): JSX.Element {
  const updateUsage = useSubscription((state) => state.updateUsage);
  const updatePriceList = useSubscription((state) => state.updatePriceList);

  const [layoutSize] = useStorage('layoutSize');
  const [inMobile, setInMobile] = useState(layoutSize === LAYOUT_SIZE.SMALL);

  useEffect(() => {
    setInMobile(layoutSize === LAYOUT_SIZE.SMALL);
  }, [layoutSize]);

  useEffect(() => {
    updatePriceList();
    updateUsage();
  }, []);

  return (
    <div
      className={classNames(
        'flex flex-col gap-4 items-center w-full max-w-[930px] mx-auto',
        inMobile ? 'mt-4' : 'mt-7'
      )}
    >
      <div
        className={classNames(
          'px-8 py-8 flex flex-col gap-12 items-center w-full rounded-[16px]',
          inMobile ? '!p-0' : 'bg-[rgba(254,253,255,0.6)] '
        )}
      >
        <UsageCurrentKey className="w-full" />
        <RemainCredits className="w-full" />
        <Pricing className="w-full" />
        <StripeBillingEntry className="w-full" />
      </div>
    </div>
  );
}

export default memo(Subscription);
